import m from "../../geodata/es2015/albaniaHigh";
window.am4geodata_albaniaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/albaniaHigh.js
// module id = null
// module chunks = 